import api from "../../../api/index"
import { repairApp } from "../../saveModule"

//-----------------------------------------------------
//-----------------------------------------------------
//-----------------------------------------------------
//-----------------------------------------------------
//-----------------------------------------------------
//getAppointCacheData：获取分类数据的方法,所有非图标组件可通用
// 需要针对列表页进行特殊处理
export async function getAppointCacheData(pageId, wfwfid, websiteId, appId, extra = {}) {
  let { useSubPageQuery, selectedDetailParam, filterClassify } = extra
  console.log("getAppointCacheData", this.$store.state.states.getDataPageIds.appId, appId)
  // 获取 获取数据的url
  let restUrl = null
  try {
    restUrl = await getGeneralRest.call(this, appId, wfwfid, websiteId, pageId, filterClassify)
  } catch (err) {
    if (err?.data?.message === "mh_engine_40009") {
      handleRepairApp.call(this, appId)
    }
    throw new Error(`接口请求错误,appid：${appId}`)
  }
  let ids = {}
  if (this.myid) {
    ids = { ...this.myid }
  } else {
    for (let k in this.ids) {
      if (typeof this.ids[k] === "number") {
        ids[k] = this.ids[k]
      }
    }
  }
  // 获取布局组件中的分类名称，标题，副标题，更多的后台数据
  // 根据选择的数据种类，对数据获取接口的参数进行处理
  if (!restUrl?.data?.data) {
    if (restUrl.data.message === "mh_engine_40002" && !this.isBigScreenPreview()) {
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        message: "数据中心未配置数据源地址，请检查数据中心！",
        type: "error"
      })
      // throw new Error(`接口请求错误,appid：${appId}，组件id:${this.$event.getIdsByStrId(ids)}`)
    }
    if (restUrl.data.message === "mh_engine_40009") {
      handleRepairApp.call(this, appId)
    }
    throw new Error(`接口请求错误,appid：${appId}，组件id:${this.$event.getIdsByStrId(ids)}`)
  }
  let { engineInstanceId, id, tempRestDataUrl, generalDataTypes, engineInstanceAppId, engineInstance, dataCenterContent } = handleRestUrls(
    restUrl.data.data
  )
  let restDataUrl = tempRestDataUrl.replace("engineInstanceId", "e").replace("typeId", "t")
  function handleGeneralDataTypes(dataTypes) {
    return dataTypes.map(item => ({
      value: item.id,
      label: item.name,
      publicId: item.publicId,
      relIds: item.relId,
      children: handleGeneralDataTypes(item.subGeneralDataTypes || [])
    }))
  }
  const cacheDataTypes = handleGeneralDataTypes(generalDataTypes)
  // 根据后端接口 只有详情页 开启了子页面传参useSubPageQuery 才传入sw修改链接
  // 数据源 https://q20i080977.goho.co/miniapp/yongkang/user/deliver/status
  if (this.$store.state[this.request_prefix].type === "detailPage" && useSubPageQuery) {
    const detailData = JSON.parse(window.localStorage.getItem("detailData"))
    let { id, formId } = detailData[0]
    const { UID, current_page_id, website_id, website_fid } = this.$store.state.states.myCookie
    // 新增详情页用户自定义的参数
    let customParam = {}
    if (selectedDetailParam && Array.isArray(selectedDetailParam)) {
      selectedDetailParam.forEach(paramName => {
        let content = null
        for (let key in detailData[0]) {
          if (detailData[0][key] && detailData[0][key].hasOwnProperty("key") && detailData[0][key].key === paramName) {
            content = detailData[0][key].value
            break
          }
        }
        customParam[paramName] = content
      })
    }
    let swData = {
      ...customParam,
      pageId: current_page_id,
      fid: website_fid,
      websiteId: website_id,
      id: id,
      formId: formId ? formId : "",
      uid: UID ? UID : ""
    }
    restDataUrl = restDataUrl + encodeURIComponent(JSON.stringify(swData))
  }

  // 使用appId作为键，将当前appId对应的分类数据保存在共享数据池中
  this.shareDataPool.setData("layout-data-type-" + appId, JSON.stringify(restUrl))

  return { engineInstanceId, id, cacheDataTypes, restDataUrl, restUrl, engineInstanceAppId, engineInstance, generalDataTypes, dataCenterContent }
}
/**
 * 获取分类数据
 * @returns
 */
async function getGeneralRest(appId, wfwfid, websiteId, pageId, filterClassify) {
  /**
   * 如果是pageType === 'listPage' 就使用首页传过来的pageId
   */
  const { homePageId, pageType } = this.$store.state.states.getDataPageIds
  if (pageType === "listPage") {
    pageId = homePageId
  }
  return api.queryAppCategoryAndApp({
    appId,
    wfwfid,
    websiteId,
    pageId,
    filterClassify
  })
}
function handleRestUrls(restUrl) {
  let { engineInstance, restDataUrl, dataCenterContent } = restUrl
  return {
    engineInstanceId: engineInstance.publicId,
    tempRestDataUrl: restDataUrl,
    generalDataTypes: restUrl.generalDataTypes,
    engineInstanceAppId: engineInstance.appPublicId,
    engineInstance:restUrl.engineInstance,
    dataCenterContent
  }
}
function handleRepairApp(appId) {
  // 根据当前appid，获取到对应的组件
  const _ids = this.myid ? this.myid : this.ids
  const options = this.$getOptions({ ..._ids })
  // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
  const isSearchComponent = options.pluginName?.includes("searchComponentPlugin")
  const isNavComponent = options.innerElement.toLowerCase().includes("nav")
  repairApp.call(this, "31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent).then(res => {
    // 替换原来的appId
    console.log("// 替换原来的appId", _ids)
    if (!!res.appId) {
      this.$changeOptionsEV(res.appId, "appId", null, false, _ids)
    }
  })
}
